import {_User} from "./_User";
import {_Admin} from "./_Admin";

export const PacchettiAPI = {
    User: _User,
    Admin: _Admin
}